var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"rounded":"lg","min-height":"268"}},[_c('v-container',[_vm._v("Repositories")]),_c('RepositoriesList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }